<template>
    <div class="responsibles">

        <box-helper
            headline="Ansvarlige"
            identifier="responsibles"
        />

        <div class="container section">
            <title-block headline="<b>Ansvarlige</b>" class="mb-xl" position="center">
                <p slot="text">
                    Ét samlet overblik over dine ansvarlige
                </p>
            </title-block>

            <!--<view-toggle
                operationsName="Drift"
                operationsLink="EmployeesOperations"
                learningName="Udvikling / læring"
                learningLink="EmployeesLearning"
                v-if="$route.name === 'EmployeesOperations'"
            />-->

            <content-switch
                :items="switchItems"
                :selectedItem="selectedItem"
                :counts="counts"
                @selectItem="handleSelectItem($event)"
            />

            <compare-responsible-employees v-show="selectedItem === 'compareResponsibleEmployees'"></compare-responsible-employees>

            <compare-project-types-for-responsibles v-show="selectedItem === 'compareProjectTypesForResponsibles'"></compare-project-types-for-responsibles>
            
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            showHelper: false,
            selectedItem: 'compareResponsibleEmployees',
            counts: {},
            switchItems: [
                {
                    name: 'Hvilke ansvarlige er gode til hvilke opgaver?',
                    slug: 'compareResponsibleEmployees'
                },
                {
                    name: 'Hvilke opgavetyper er den enkelte ansvarlige god til?',
                    slug: 'compareProjectTypesForResponsibles'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
        }
    },
    components: {
        'compare-responsible-employees': require('./learning/compareResponsibleEmployees.vue'),
        'compare-project-types-for-responsibles': require('./learning/compareProjectTypesForResponsibles.vue')
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?f1225a8a